<template lang="pug" src='./hero-pages.pug'></template>

<script>
import Icon from 'components/icon/icon'

import { openModal } from '@/methods'

export default {
  props: ['props'],
  mixins: [ openModal ],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// hero-pages.vue?6dfb2dbb